import { Component } from '@theme/component';
import { ThemeEvents } from '@theme/events';

/**
 * @typedef {object} OutOfStockSubscribeRefs
 * @property {HTMLButtonElement} trigger
 * @property {HTMLDialogElement} dialog
 * @property {HTMLButtonElement} closeButton
 * @property {HTMLDialogElement} successDialog
 * @property {HTMLInputElement} tagsInput
 * @property {HTMLFormElement} [submitButton]
 */

/** @extends {Component<OutOfStockSubscribeRefs>} */
class OutOfStockSubscribe extends Component {
  requiredRefs = ['trigger', 'dialog', 'closeButton', 'successDialog', 'tagsInput'];

  connectedCallback() {
    super.connectedCallback();

    this.refs.trigger.addEventListener('click', this.#openDialog);
    this.refs.closeButton.addEventListener('click', this.#closeDialog);
    this.refs.dialog.addEventListener('click', this.#handleDialogClick);

    const customerForm = this.querySelector('.oos-subscribe__customer-form');
    customerForm?.addEventListener('submit', this.#handleSubmit);

    const productForm = this.closest('product-form-component');
    productForm?.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
    document.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.refs.trigger.removeEventListener('click', this.#openDialog);
    this.refs.closeButton.removeEventListener('click', this.#closeDialog);
    this.refs.dialog.removeEventListener('click', this.#handleDialogClick);

    const customerForm = this.querySelector('.oos-subscribe__customer-form');
    customerForm?.removeEventListener('submit', this.#handleSubmit);

    const productForm = this.closest('product-form-component');
    productForm?.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
    document.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  #openDialog = () => {
    if (this.refs.dialog.open) return;
    this.refs.dialog.showModal();
  };

  #closeDialog = () => {
    if (!this.refs.dialog.open) return;
    this.refs.dialog.close();
  };

  #handleDialogClick = (event) => {
    if (event.target === this.refs.dialog) {
      this.#closeDialog();
    }
  };

  /** @param {SubmitEvent} event */
  #handleSubmit = () => {
    const { tagsInput } = this.refs;
    const currentUrl = window.location.href;
    const baseTags = '缺货订阅';
    const productTitle = this.dataset.productTitle || '';
    const selectedOption = this.querySelector('input[name="ms02_option"]:checked');
    const ms02Tags = selectedOption ? `,MS02-Option:${selectedOption.value}` : '';

    if (productTitle) {
      tagsInput.value = `${baseTags},Page:${currentUrl},Product:${productTitle},NAS${ms02Tags}`;
    } else {
      tagsInput.value = `${baseTags},Page:${currentUrl},NAS${ms02Tags}`;
    }

    window.setTimeout(() => {
      this.#closeDialog();
      if (!this.refs.successDialog.open) {
        this.refs.successDialog.showModal();
      }
      window.setTimeout(() => {
        if (this.refs.successDialog.open) {
          this.refs.successDialog.close();
        }
      }, 4500);
    }, 500);
  };

  /** @param {CustomEvent} event */
  #onVariantUpdate = (event) => {
    if (event.detail?.data?.productId !== this.dataset.productId) return;

    const available = event.detail.resource?.available ?? false;
    this.#toggleSubscribe(!available);
  };

  /** @param {boolean} showSubscribe */
  #toggleSubscribe(showSubscribe) {
    this.hidden = !showSubscribe;

    const scope =
      this.closest('.buy-buttons-block') ||
      this.closest('.form-action') ||
      this.closest('.product-sticky-actions') ||
      this.closest('product-form-component')?.parentElement;

    if (!scope) return;

    const addToCart = scope.querySelector('add-to-cart-component');
    const buyButtons = scope.querySelector('.product-form-buttons');

    if (addToCart) {
      addToCart.hidden = showSubscribe;
    }

    if (buyButtons) {
      buyButtons.hidden = showSubscribe;
    }
  }
}

if (!customElements.get('out-of-stock-subscribe')) {
  customElements.define('out-of-stock-subscribe', OutOfStockSubscribe);
}
